module.exports = __webpack_public_path__ + "assets/email.png";


//////////////////
// WEBPACK FOOTER
// ./images/email.png
// module id = 300
// module chunks = 0